<div class="arkik-pwa-sheet">
  <div class="sheet-content">
    <!-- Barra de arrastre superior estilo iOS -->
    <div class="sheet-handle"></div>

    <!-- Header Ejecutivo con Identidad Arkik -->
    <header class="sheet-header">
      <div class="brand-badge">
        <!-- Isotipo Arkik en SVG -->
        <img class="arkik-logo-icon" src="assets/icons/pwa/apple-touch-icon.png" alt="ARKIK" />
        <div class="brand-titles">
          <span class="badge-tag">{{ 'views.globals.pwa-install.web-app' | translation }}</span>
          <h2 class="title" id="pwa-install-title">{{ 'views.globals.pwa-install.title' | translation }}</h2>
        </div>
      </div>
    </header>

    <p *ngIf="!safari" class="browser-advice">{{ 'views.globals.pwa-install.other-browser' | translation }}</p>

    <!-- Escenario de Animación Interactiva -->
    <div class="animation-stage" aria-hidden="true" [class.paused]="!autoPlay || isManualSelection">
      <div class="iphone-mockup" [attr.data-step]="currentStep">
        <!-- Notch / Dynamic Island -->
        <div class="iphone-notch"></div>

        <!-- Pantalla del Dispositivo -->
        <div class="iphone-screen">
          <!-- ESCENA 1: Barra de Safari y pulso en el botón Share -->
          <div class="scene scene-1" [class.active]="currentStep === 1">
            <div class="app-preview-skeleton">
              <div class="skeleton-header"></div>
              <div class="skeleton-card primary"></div>
              <div class="skeleton-grid">
                <div class="skeleton-box"></div>
                <div class="skeleton-box"></div>
              </div>
            </div>

            <!-- Barra inferior de Safari -->
            <div class="safari-bottom-bar">
              <span class="safari-nav-icon">&#8249;</span>
              <span class="safari-nav-icon">&#8250;</span>

              <!-- Ícono de Compartir con Ripple/Touch Effect -->
              <div class="safari-share-btn">
                <div class="touch-ripple"></div>
                <svg
                  viewBox="0 0 24 24"
                  width="18"
                  height="18"
                  stroke="#0085FF"
                  stroke-width="2.2"
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"></path>
                  <polyline points="16 6 12 2 8 6"></polyline>
                  <line x1="12" y1="2" x2="12" y2="15"></line>
                </svg>
              </div>

              <span class="safari-nav-icon">&#10063;</span>
              <span class="safari-nav-icon">&#9723;</span>
            </div>
          </div>

          <!-- ESCENA 2: Action Sheet de iOS y selección de "Agregar a inicio" -->
          <div class="scene scene-2" [class.active]="currentStep === 2">
            <div class="ios-action-sheet">
              <div class="sheet-app-info">
                <div class="mini-arkik-icon"></div>
                <div class="mini-lines">
                  <div class="line-bold">Arkik</div>
                  <div class="line-sub">Safari</div>
                </div>
              </div>

              <div class="sheet-menu-list">
                <div class="menu-item muted">
                  <span>{{ 'views.globals.pwa-install.copy-link' | translation }}</span>
                  <span class="item-icon">&#128279;</span>
                </div>
                <!-- Item Destacado -->
                <div class="menu-item highlighted">
                  <div class="touch-indicator-step2"></div>
                  <span>{{ 'views.globals.pwa-install.home-screen-label' | translation }}</span>
                  <div class="add-box-icon">
                    <svg viewBox="0 0 24 24" width="16" height="16" stroke="#0085FF" stroke-width="2.2" fill="none">
                      <rect x="3" y="3" width="18" height="18" rx="4"></rect>
                      <line x1="12" y1="8" x2="12" y2="16"></line>
                      <line x1="8" y1="12" x2="16" y2="12"></line>
                    </svg>
                  </div>
                </div>
                <div class="menu-item muted">
                  <span>{{ 'views.globals.pwa-install.bookmark' | translation }}</span>
                  <span class="item-icon">&#128278;</span>
                </div>
              </div>
            </div>
          </div>

          <!-- ESCENA 3: Confirmación y aparición del ícono en el Home Screen -->
          <div class="scene scene-3" [class.active]="currentStep === 3">
            <div class="ios-confirm-dialog">
              <div class="dialog-top-bar">
                <span class="cancel-txt">{{ 'views.globals.pwa-install.cancel' | translation }}</span>
                <span class="title-txt">{{ 'views.globals.pwa-install.home-screen-label' | translation }}</span>
                <span class="add-btn-highlight">
                  {{ 'views.globals.pwa-install.add-label' | translation }}
                  <span class="touch-ripple-small"></span>
                </span>
              </div>

              <div class="home-screen-preview">
                <div class="installed-app-badge">
                  <div class="arkik-app-tile">
                    <svg viewBox="0 0 48 48" width="28" height="28" fill="none">
                      <path
                        d="M12 10H28C32.4183 10 36 13.5817 36 18V40"
                        stroke="#54C1FF"
                        stroke-width="6"
                        stroke-linecap="round"
                      />
                      <path
                        d="M26 10H14C10.6863 10 8 12.6863 8 16V30C8 33.3137 10.6863 36 14 36H40"
                        stroke="#0085FF"
                        stroke-width="6"
                        stroke-linecap="round"
                      />
                    </svg>
                    <div class="success-check">
                      <svg viewBox="0 0 24 24" width="12" height="12" stroke="#FFFFFF" stroke-width="3" fill="none">
                        <polyline points="20 6 9 17 4 12"></polyline>
                      </svg>
                    </div>
                  </div>
                  <span class="app-label">Arkik</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Controles de Paso y Explicación Dinámica -->
    <div class="step-details-container">
      <div class="step-selector">
        <button
          *ngFor="let s of steps"
          type="button"
          class="step-pill"
          [class.active]="currentStep === s.stepNumber"
          (click)="selectStep(s.stepNumber)"
          [attr.aria-pressed]="currentStep === s.stepNumber"
          [attr.aria-controls]="'pwa-step-' + s.stepNumber"
          [attr.data-testid]="'pwa-install-step-' + s.stepNumber"
        >
          <span class="step-num">{{ 'views.globals.pwa-install.step' | translation }} {{ s.stepNumber }}</span>
          <div class="progress-bar" *ngIf="currentStep === s.stepNumber && autoPlay && !isManualSelection"></div>
        </button>
      </div>

      <div
        class="step-text-box"
        *ngFor="let s of steps"
        [hidden]="currentStep !== s.stepNumber"
        [id]="'pwa-step-' + s.stepNumber"
      >
        <h3 class="step-title">{{ s.title | translation }}</h3>
        <p class="step-desc">{{ s.description | translation }}</p>
      </div>
      <label class="motion-control">
        <input type="checkbox" [checked]="autoPlay" (change)="toggleAutoCycle()" data-testid="pwa-install-autoplay" />
        {{ 'views.globals.pwa-install.autoplay' | translation }}
      </label>
    </div>

    <p class="browser-advice">{{ 'views.globals.pwa-install.safari-fallback' | translation }}</p>
  </div>

  <!-- Footer Ejecutivo -->
  <footer class="sheet-footer">
    <cwc-button variant="regular-block" (cwcClick)="closePrompt()" data-testid="pwa-install-close">
      {{ 'views.globals.pwa-install.understood' | translation }}
    </cwc-button>
  </footer>
</div>
